"use strict";

class PropertyQuestionnaireController {

    constructor(Upload, $window, $sce, SSHttpService, SSUtilService, SSAlertService, SSConfigService, SSUserService, OTPService, $timeout, $localStorage, $cookies) {
        const self = this;
        self.Upload = Upload;
        self.$window = $window;
        self.$timeout = $timeout;
        self.sce = $sce;
        self.$localStorage = $localStorage;
        self.$cookies = $cookies;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;

        self.data = SHOWSUITE.data;
        self.property = SHOWSUITE.data.property;
        self.property_id = SHOWSUITE.data.property_id;
        self.EDITOR_API_KEY = SHOWSUITE.data.EDITOR_API_KEY;

        self.QUESTION_TYPE_YES_NO = SHOWSUITE.QUESTION_TYPE_YES_NO;
        self.QUESTION_TYPE_YES_NO_NA = SHOWSUITE.QUESTION_TYPE_YES_NO_NA;
        self.QUESTION_TYPE_TEXT = SHOWSUITE.QUESTION_TYPE_TEXT;
        self.QUESTION_TYPE_NUMBER = SHOWSUITE.QUESTION_TYPE_NUMBER;
        self.QUESTION_TYPE_SELECT = SHOWSUITE.QUESTION_TYPE_SELECT;
        self.QUESTION_TYPE_CHECKBOX = SHOWSUITE.QUESTION_TYPE_CHECKBOX;
        self.QUESTION_TYPE_RADIO = SHOWSUITE.QUESTION_TYPE_RADIO;
        self.QUESTION_TYPE_DATE = SHOWSUITE.QUESTION_TYPE_DATE;

        self.QUESTION_MARKER_NO_OF_OWNED_PROPERTIES = SHOWSUITE.QUESTION_MARKER_NO_OF_OWNED_PROPERTIES;
        self.QUESTION_MARKER_ELITE_MEMBERSHIP_APPLICATION_FORM = SHOWSUITE.QUESTION_MARKER_ELITE_MEMBERSHIP_APPLICATION_FORM;
        self.QUESTION_MARKER_MARKETING_SOURCE = SHOWSUITE.QUESTION_MARKER_MARKETING_SOURCE;
        self.QUESTION_MARKER_PURCHASE_INTENTION = SHOWSUITE.QUESTION_MARKER_PURCHASE_INTENTION;
        self.QUESTION_MARKER_TRUE_PURCHASER = SHOWSUITE.QUESTION_MARKER_TRUE_PURCHASER;
        self.QUESTION_MARKER_BENEFICIAL_OWNER = SHOWSUITE.QUESTION_MARKER_BENEFICIAL_OWNER;
        self.QUESTION_MARKER_FOREIGN_PEP = SHOWSUITE.QUESTION_MARKER_FOREIGN_PEP;
        self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL = SHOWSUITE.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL;
        self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS = SHOWSUITE.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS;
        self.QUESTION_MARKER_SPECIAL_CONDITIONS = SHOWSUITE.QUESTION_MARKER_SPECIAL_CONDITIONS;
        self.QUESTION_MARKER_OFFER_PRICE = SHOWSUITE.QUESTION_MARKER_OFFER_PRICE;
        self.QUESTION_MARKER_KEY_HANDOVER_CDD_DOCUMENTS = SHOWSUITE.QUESTION_MARKER_KEY_HANDOVER_CDD_DOCUMENTS;
        self.QUESTION_MARKER_KEY_HANDOVER_CONSISTENT_TRANSACTIONS = SHOWSUITE.QUESTION_MARKER_KEY_HANDOVER_CONSISTENT_TRANSACTIONS;
        self.QUESTION_MARKER_KEY_HANDOVER_RISK_ML = SHOWSUITE.QUESTION_MARKER_KEY_HANDOVER_RISK_ML;
        self.QUESTION_MARKER_IDENTITY_TYPE_SINGAPOREAN = SHOWSUITE.QUESTION_MARKER_IDENTITY_TYPE_SINGAPOREAN;
        self.QUESTION_MARKER_IDENTITY_TYPE_SINGAPOREAN_PR = SHOWSUITE.QUESTION_MARKER_IDENTITY_TYPE_SINGAPOREAN_PR;
        self.QUESTION_MARKER_IDENTITY_TYPE_FOREIGNER = SHOWSUITE.QUESTION_MARKER_IDENTITY_TYPE_FOREIGNER;
        self.QUESTION_MARKER_POA_REPRESENTATION = SHOWSUITE.QUESTION_MARKER_POA_REPRESENTATION;

        /*
        * Question groups
        */
        self.QUESTION_GROUP_INDIVIDUAL = SHOWSUITE.QUESTION_GROUP_INDIVIDUAL;   //  10
        self.QUESTION_GROUP_COMPANY = SHOWSUITE.QUESTION_GROUP_COMPANY;  //  20
        self.QUESTION_GROUP_SIGNATORY = SHOWSUITE.QUESTION_GROUP_SIGNATORY;  //  30
        self.QUESTION_GROUP_BOTH_INDIVIDUAL_N_COMPANY = SHOWSUITE.QUESTION_GROUP_BOTH_INDIVIDUAL_N_COMPANY;  //  40
        self.QUESTION_GROUP_BOTH_INDIVIDUAL_N_SIGNATORY = SHOWSUITE.QUESTION_GROUP_BOTH_INDIVIDUAL_N_SIGNATORY;  //  50

        /*
        * Question Phase
        */
        self.QUESTION_PHASE_EOI = SHOWSUITE.QUESTION_PHASE_EOI;   //  10
        self.QUESTION_PHASE_BOOKING = SHOWSUITE.QUESTION_PHASE_BOOKING;  //  20
        self.QUESTION_PHASE_KEY_HANDOVER = SHOWSUITE.QUESTION_PHASE_KEY_HANDOVER;  //  30

        /*
        * Question Entity Types
        */
        self.QUESTION_ENTITY_TYPE_BUYER = SHOWSUITE.QUESTION_ENTITY_TYPE_BUYER;   //  10
        self.QUESTION_ENTITY_TYPE_NON_BUYER_PAYEE = SHOWSUITE.QUESTION_ENTITY_TYPE_NON_BUYER_PAYEE;  //  20
        self.QUESTION_ENTITY_TYPE_BROKER_TEAM_LEAD = SHOWSUITE.QUESTION_ENTITY_TYPE_BROKER_TEAM_LEAD;  //  30
        self.QUESTION_ENTITY_TYPE_DEVELOPER = SHOWSUITE.QUESTION_ENTITY_TYPE_DEVELOPER;  //  40
        self.QUESTION_ENTITY_TYPE_BROKER = SHOWSUITE.QUESTION_ENTITY_TYPE_BROKER;  //  50
        self.QUESTION_ENTITY_TYPE_POWER_OF_ATTORNEY = SHOWSUITE.QUESTION_ENTITY_TYPE_POWER_OF_ATTORNEY;  //  60
        self.QUESTION_ENTITY_TYPE_OTHER_BENEFICIARY = SHOWSUITE.QUESTION_ENTITY_TYPE_OTHER_BENEFICIARY;  //  70
        self.QUESTION_ENTITY_TYPE_TRUE_PURCHASER = SHOWSUITE.QUESTION_ENTITY_TYPE_TRUE_PURCHASER;  //  80

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.editor = null;
        self.editorLang = null;
        self.question_obj = [];
        self.parent_questions = [];
        self.active_entity_type = self.QUESTION_ENTITY_TYPE_BUYER;

        self.setQuestionTypeValues();
        self.setQuestionMarkerValues();
        self.setQuestionGroupValues();
        self.setQuestionPhaseTypeValues();
        //self.getProperty();
        self.getPropertyQuestions();

        self.language = self.$localStorage['language'];
        self.localizeParam = {
            question_text: '',
        };
        self.selectedLanguage = '';
    }

    getProperty() {
        const self = this;

        if (!self.data.property_id)
            return;

        self.property = null;

        let url = 'sec/developer/properties/' + self.data.property_id;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.property = response.data.property;
            self.getPropertyQuestions();
        });
    }

    getPropertyQuestions() {
        const self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/questions';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.questions = response.data.property_questions;
            self.getFilteredQuestions(self.active_entity_type);
        });
    }

    getFilteredQuestions(entityType) {
        const self = this;

        self.active_entity_type = entityType;
        self.filtered_questions = [];
        self.parent_questions = [];

        if (!self.questions) {
            return;
        }

        $.each(self.questions, function (i, question) {
            if (question.entity_type === self.active_entity_type) {
                self.filtered_questions.push(question);

                //if (!question.parent_question_id) {
                self.parent_questions.push({
                    'id': question.id,
                    'name': question.question_text
                });
                //}
            }
        });

        self.filtered_questions = _.sortBy(self.filtered_questions, 'order');

        self.$timeout(function () {
            $("select.eoi-select#parent_question_select").niceSelect('update');
            // $("select.eoi-select#marker_select").niceSelect('update');
        });
    }

    setQuestionTypeValues() {
        const self = this;

        self.question_types = [
            {
                'id': self.QUESTION_TYPE_YES_NO,
                'name': 'YES/NO'
            },
            {
                'id': self.QUESTION_TYPE_YES_NO_NA,
                'name': 'YES/NO/NA'
            },
            {
                'id': self.QUESTION_TYPE_TEXT,
                'name': 'TEXT'
            },
            {
                'id': self.QUESTION_TYPE_NUMBER,
                'name': 'NUMBER'
            },
            {
                'id': self.QUESTION_TYPE_SELECT,
                'name': 'SELECT'
            },
            {
                'id': self.QUESTION_TYPE_CHECKBOX,
                'name': 'CHECKBOX'
            },
            {
                'id': self.QUESTION_TYPE_RADIO,
                'name': 'RADIO'
            },
            {
                'id': self.QUESTION_TYPE_DATE,
                'name': 'DATE'
            }
        ];


        self.$timeout(function () {
            $("select.eoi-select#questionaire_select").niceSelect('update');
        });
    }

    setQuestionMarkerValues() {
        const self = this;

        self.question_markers = [
            {
                'id': self.QUESTION_MARKER_NO_OF_OWNED_PROPERTIES,
                'name': 'Number of owned Properties'
            },
            {
                'id': self.QUESTION_MARKER_ELITE_MEMBERSHIP_APPLICATION_FORM,
                'name': 'Elite Membership Application Form'
            },
            {
                'id': self.QUESTION_MARKER_MARKETING_SOURCE,
                'name': 'Marketing Source'
            },
            {
                'id': self.QUESTION_MARKER_PURCHASE_INTENTION,
                'name': 'Purchase Intent'
            },
            {
                'id': self.QUESTION_MARKER_TRUE_PURCHASER,
                'name': 'True Purchaser'
            },
            {
                'id': self.QUESTION_MARKER_BENEFICIAL_OWNER,
                'name': 'Beneficial Owner'
            },
            {
                'id': self.QUESTION_MARKER_FOREIGN_PEP,
                'name': 'Foreign PEP'
            },
            {
                'id': self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL,
                'name': 'AML Risk Assessment Level'
            },
            {
                'id': self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS,
                'name': 'AML Risk Assessment Remarks'
            },
            {
                'id': self.QUESTION_MARKER_SPECIAL_CONDITIONS,
                'name': 'Special Conditions'
            },
            {
                'id': self.QUESTION_MARKER_OFFER_PRICE,
                'name': 'Offer Price'
            },
            {
                'id': self.QUESTION_MARKER_KEY_HANDOVER_CDD_DOCUMENTS,
                'name': 'Key Handover CDD Documents'
            },
            {
                'id': self.QUESTION_MARKER_KEY_HANDOVER_CONSISTENT_TRANSACTIONS,
                'name': 'Key Handover Consistent Transactions'
            },
            {
                'id': self.QUESTION_MARKER_KEY_HANDOVER_RISK_ML,
                'name': 'Key Handover Risk Money Laundering'
            },
            {
                'id': self.QUESTION_MARKER_IDENTITY_TYPE_SINGAPOREAN,
                'name': 'Identity Type Singaporean'
            },
            {
                'id': self.QUESTION_MARKER_IDENTITY_TYPE_SINGAPOREAN_PR,
                'name': 'Identity Type Singaporean PR'
            },
            {
                'id': self.QUESTION_MARKER_IDENTITY_TYPE_FOREIGNER,
                'name': 'Identity Type Foreigner'
            },
            {
                'id': self.QUESTION_MARKER_POA_REPRESENTATION,
                'name': 'POA representation'
            },
        ];

        // self.$timeout(function () {
        //     $("select.eoi-select#marker_select").niceSelect('update');
        // });
    }

    setQuestionGroupValues() {
        const self = this;

        self.question_groups = [
            {
                'id': self.QUESTION_GROUP_INDIVIDUAL,
                'name': 'Individual'
            },
            {
                'id': self.QUESTION_GROUP_COMPANY,
                'name': 'Company'
            },
            {
                'id': self.QUESTION_GROUP_SIGNATORY,
                'name': 'Signatory'
            },
            {
                'id': self.QUESTION_GROUP_BOTH_INDIVIDUAL_N_COMPANY,
                'name': 'Individual and Company'
            },
            {
                'id': self.QUESTION_GROUP_BOTH_INDIVIDUAL_N_SIGNATORY,
                'name': 'Individual and Signatory'
            }
        ];

        self.$timeout(function () {
            $("select.eoi-select#group_select").niceSelect('update');
        });
    }

    getQuestionGroupName(type) {
        const self = this;

        let name = 'All';
        if (type) {
            $.each(self.question_groups, function (i, o) {
                if (o.id === type) {
                    name = o.name;
                    return false;
                }
            });
        }
        return name;
    }

    setQuestionPhaseTypeValues() {
        const self = this;

        self.question_phase_types = [
            {
                'id': self.QUESTION_PHASE_EOI,
                'name': 'EOI'
            },
            {
                'id': self.QUESTION_PHASE_BOOKING,
                'name': 'BOOKING'
            },
            {
                'id': self.QUESTION_PHASE_KEY_HANDOVER,
                'name': 'KEY HANDOVER'
            }
        ];

        self.$timeout(function () {
            $("select.eoi-select#phase_type_select").niceSelect('update');
        });
    }

    getQuestionPhaseTypeName(type) {
        const self = this;

        let name = 'All';
        if (type) {
            $.each(self.question_phase_types, function (i, o) {
                if (o.id === type) {
                    name = o.name;
                    return false;
                }
            });
        }
        return name;
    }

    renderHtml(content) {
        const self = this;

        // WEB-3597 — allow-list sanitise rich text before trusting it for ng-bind-html.
        return self.sce.trustAsHtml(window.ssSanitizeHtml(content));
    }

    showChoices() {
        const self = this;

        let flag = false;

        if (self.question_type == self.QUESTION_TYPE_SELECT || self.question_type == self.QUESTION_TYPE_CHECKBOX
            || self.question_type == self.QUESTION_TYPE_RADIO) {
            flag = true;
        }

        return flag;
    }
    questionTypeTexOrChoices(){
        const self = this;
        self.standard_answer_ind = "";
        self.standard_answer_corp = "";
        self.question_choices_answers = [];
        if(self.question_type == self.QUESTION_TYPE_YES_NO){
            self.question_choices_answers = ["YES", "NO"];
            self.isQuestionTypeTexOrChoices = true;
        }else if(self.question_type == self.QUESTION_TYPE_YES_NO_NA){
            self.question_choices_answers = ["YES", "NO", "N/A"];
            self.isQuestionTypeTexOrChoices = true;
        }else if(self.question_type == self.QUESTION_TYPE_SELECT || self.question_type == self.QUESTION_TYPE_CHECKBOX ||
            self.question_type == self.QUESTION_TYPE_RADIO){
            if(self.question_choices && self.question_choices != ""){
                self.question_choices_answers = self.question_choices.split(/\r?\n/)
            }
            self.isQuestionTypeTexOrChoices = true;
        }else{
            self.isQuestionTypeTexOrChoices = false;
        }
    }

    updateStandardAnswerList(){
        const self = this;
        self.standard_answer_ind = "";
        self.standard_answer_corp = "";
        self.question_choices_answers = [];
        if(self.question_type == self.QUESTION_TYPE_SELECT || self.question_type == self.QUESTION_TYPE_CHECKBOX ||
            self.question_type == self.QUESTION_TYPE_RADIO){
            if(self.question_choices && self.question_choices != ""){
                self.question_choices_answers = self.question_choices.split(/\r?\n/)
            }
        }
    }
    getQuestionTypeName(type_id) {
        const self = this;

        let type_name = '';

        try {
            type_name = self.question_types.find(x => x.id == type_id).name;
        } catch (ex) {
            console.log(ex);
        }

        return type_name;
    }

    getQuestionMarkerName(marker) {
        const self = this;

        if(!marker){ return "";}

        let name = '';
        try {
            let markers = marker.split(',');
            if (markers && markers.length){
                let fitered_markers = self.question_markers.filter(x => markers.includes(""+x.id))
                if (fitered_markers && fitered_markers.length){
                    fitered_markers.forEach(m => {
                        name = name ? name+", " : name;
                        name += m.name;
                    })
                }
            }
        } catch (ex) {
            console.log(ex);
        }

        return name;
    }

    onDeleteQuestion(question_id) {
        const self = this;

        self.hideModals();
        self.showDeleteModal = true;
        self.delete_question_id = question_id;
        $('#deleteQuestionModal').modal('show');
    }

    deleteQuestion() {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            let url = 'sec/developer/properties/' + self.property_id + '/questions/' + self.delete_question_id + '/delete';
            self.hideModals();

            loading(true);
            self.SSHttpService.getAPIRequest(url).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.warning('Warning!', 'This question can not be deleted.');
                    return;
                }
                self.SSAlertService.success('Success!', 'Question deleted successfully');

                self.questions = $.grep(self.questions, function (e) {
                    return e.id != self.delete_question_id;
                });

                self.getFilteredQuestions(self.active_entity_type);
            });
        });
    }

    initEditorData() {
        const self = this;

        if (self.editor) {
            self.editor.destroy();
        }

        var buttons = [
            'bold', 'italic', 'underline', 'strikeThrough',
            '|', 'subscript', 'superscript',
            '|', 'paragraphFormat', 'paragraphStyle', 'inlineStyle', 'align',
            '|', 'formatOL', 'formatUL', 'outdent', 'indent', 'selectAll',
            '-', 'insertHR', 'clearFormatting',
            '|', 'html',
            '|', 'undo', 'redo',
        ];

        // Init Froala Editor
        self.editor = new FroalaEditor('div#froala-editor', {
            key: self.EDITOR_API_KEY,
            toolbarInline: true,
            placeholderText: '',
            charCounterCount: false,
            height: 200,

            toolbarButtons: buttons,
            toolbarButtonsMD: buttons,
            toolbarButtonsSM: buttons,
            toolbarButtonsXS: buttons,

            htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr'],
            htmlRemoveTags: []
        }, function () {
            self.editor.html.set(self.question_text);
        });

        if (self.editorLang) {
            self.editorLang.destroy();
        }

        self.editorLang = new FroalaEditor('div#froalaLang-editor', {
            key: self.EDITOR_API_KEY,
            toolbarInline: true,
            placeholderText: '',
            charCounterCount: false,
            height: 200,

            toolbarButtons: buttons,
            toolbarButtonsMD: buttons,
            toolbarButtonsSM: buttons,
            toolbarButtonsXS: buttons,

            htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr'],
            htmlRemoveTags: []
        }, function () {
            self.editorLang.html.set(self.localizeParam.question_text);
        });

        $('.fr-toolbar').css('z-index', '10001');
        $('.fr-tooltip').css('z-index', '10001');

        self.clearSelectize('question_marker_multiple');
        var _question_markers = self.question_markers;
        self.$timeout(function(){
            var $select = $('#question_marker_multiple').selectize({
                valueField: 'id',
                labelField: 'name',
                sortDirection: 'desc',
                maxItems: null,
                options: _question_markers,
                items: null
            });}, 0);
    }

    onUpdateQuestion(question_id) {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

            self.hideModals();
            self.showQuestiontModal = true;
            self.update_question_id = question_id;

            self.resetErrors();
            self.add_question = false;
            self.update_question = true;

            let question_obj = self.questions.find(x => x.id === question_id);
            self.question_text = question_obj.question_text;

            self.initializeFields(question_obj);

            // Clearing language dropdown
            self.selectedLanguage = '';

            $('#addQuestiontModal').modal('show');
            self.initEditorData();
        });

    }

    updateQuestion() {
        const self = this;

        let url = 'sec/developer/properties/' + self.property_id + '/questions/' + self.update_question_id;
        self.question_text = new FroalaEditor('div#froala-editor').html.get(true);

        let choices = '';
        if (self.question_choices) {
            choices = JSON.stringify(self.question_choices.split(/\r?\n/));
        }

        /** WEB-2937 Corporate Sale - Support for Multiple Signatories **/
        if(self.active_entity_type === self.QUESTION_ENTITY_TYPE_BROKER_TEAM_LEAD
                || self.active_entity_type === self.QUESTION_ENTITY_TYPE_DEVELOPER
        || self.active_entity_type === self.QUESTION_ENTITY_TYPE_BROKER){
            self.question_group = null; // Clear group for Dev and Team IC questions
        }

        let params = {
            parent_question_id: self.parent_question_id,
            parent_question_answer: self.parent_question_answer ? JSON.stringify(self.parent_question_answer) : null,
            question_text: self.question_text,
            type: self.question_type,
            marker: self.question_marker ? self.question_marker.join(",") : null,
            entity_type: self.question_entity_type,
            group: self.question_group,
            phase_type: self.question_phase_type,
            choices: choices,
            order: self.question_order,
            is_active: self.is_active ? 1 : 0,
            is_required: self.is_required ? 1 : 0,
            is_first_buyer_only: self.is_first_buyer_only ? 1 : 0,
            standard_answer_ind: self.standard_answer_ind,
            standard_answer_corp: self.standard_answer_corp,
            parent_question_answer_comparison: self.parent_question_answer_comparison

        };

        if (!self.isValidInput()) {
            return;
        }

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'Question updated successfully');

            self.questions = $.grep(self.questions, function (e) {
                return e.id != response.data.property_question.id;
            });
            self.questions.push(response.data.property_question);

            self.getFilteredQuestions(self.active_entity_type);
            self.saveLanguageParam();
        });
    }

    addQuestion() {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

            self.hideModals();
            self.showQuestiontModal = true;
            self.resetErrors();
            self.resetFields();

            self.update_question = false;
            self.add_question = true;

            $('#addQuestiontModal').modal('show');
            self.question_text = '';

            self.initEditorData("");
        });
    }

    exportQuestions() {
        const self = this;
        let url = 'sec/developer/properties/' + self.property.id + '/property-questions-export';
        url = self.SSHttpService.getApiURL(url);
        self.$window.location.href  = url;
            self.SSAlertService.success('Question exported successfully.');
    }

    importQuestions(file) {
        const self = this;

        if (!file) {
            return;
        }

        let url = self.SSHttpService.getApiURL('sec/developer/import/property-questions');

        loading(true);
        console.log(url);
        console.log( self.property.id);
        self.Upload.upload({
            url: url,
            method: 'POST',
            data: {
                import_file: file,
                property_id: self.property.id
            },
            withCredentials: true
        }).then(function (response) {
            loading(false);

            response = response.data ? response.data : {};

            if (response.code !== 200) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success("Success!", "Questions imported successfully");
            self.getPropertyQuestions();

        }, function (response) {
            loading(false);

            self.SSAlertService.parseAndDisplayError(response);
        });
    }

    saveQuestion() {
        const self = this;

        self.resetErrors();

        let url = 'sec/developer/properties/' + self.property_id + '/questions';
        // self.question_text = $('div#froala-editor').froalaEditor('html.get');
        self.question_text = new FroalaEditor('div#froala-editor').html.get(true);

        let choices = '';
        if (self.question_choices) {
            choices = JSON.stringify(self.question_choices.split(/\r?\n/));
        }

        /** WEB-2937 Corporate Sale - Support for Multiple Signatories **/
        if(self.active_entity_type === self.QUESTION_ENTITY_TYPE_BROKER_TEAM_LEAD
                || self.active_entity_type === self.QUESTION_ENTITY_TYPE_DEVELOPER ||
            self.active_entity_type === self.QUESTION_ENTITY_TYPE_BROKER){
            self.question_group = null; // Clear group for Dev and Team IC questions
        }

        let params = {
            parent_question_id: self.parent_question_id,
            parent_question_answer: self.parent_question_answer ? JSON.stringify(self.parent_question_answer) : null,
            question_text: self.question_text,
            type: self.question_type,
            marker:  self.question_marker ? self.question_marker.join(",") : null,
            entity_type: self.question_entity_type,
            group: self.question_group,
            phase_type: self.question_phase_type,
            choices: choices,
            order: self.question_order,
            is_active: self.is_active ? 1 : 0,
            is_required: self.is_required ? 1 : 0,
            is_first_buyer_only: self.is_first_buyer_only ? 1 : 0,
            standard_answer_ind: self.standard_answer_ind,
            standard_answer_corp: self.standard_answer_corp,
            parent_question_answer_comparison: self.parent_question_answer_comparison
        };

        if (!self.isValidInput()) {
            return;
        }

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Question added successfully.');
            self.questions.push(response.data.property_question);
            self.getFilteredQuestions(self.active_entity_type);
        });
    }

    isValidInput() {
        const self = this;

        let isValid = true;

        if (!self.question_text) {
            self.error_question_text = 'The question text field is required.';
            isValid = false;
        }
        if (!self.question_type) {
            self.error_question_type = 'The question type field is required.';
            isValid = false;
        }

        return isValid;
    }

    initializeFields(question) {
        const self = this;

        self.question_text = question.question_text;
        self.question_type = question.type;
        self.question_marker = typeof question.marker === 'string' ? (question.marker ? question.marker.split(",").map(Number) : null) :  question.marker;
        if(typeof question.marker === 'string' || question.marker == null ){
            self.clearSelectize('question_marker_multiple');
            var _question_marker = self.question_marker;
            var _question_markers = self.question_markers;
            self.$timeout(function(){
                var $select = $('#question_marker_multiple').selectize({
                    valueField: 'id',
                    labelField: 'name',
                    sortDirection: 'desc',
                    maxItems: null,
                    options: _question_markers,
                    items: _question_marker
                });}, 0);
        }else{
            self.isShowingOldMarkerUI = true;
        }
        self.parent_question_id = question.parent_question_id;
        self.parent_question_answer = question.parent_question_id ? question.parent_question_answer : null;
        self.parent_question_answer_comparison = question.parent_question_answer_comparison ? question.parent_question_answer_comparison : null;
        if(question.parent_question_id ) {
            let parent_question_obj = self.questions.find(x => x.id === question.parent_question_id);
            if(parent_question_obj && (parent_question_obj.type === self.QUESTION_TYPE_YES_NO || parent_question_obj.type === self.QUESTION_TYPE_YES_NO_NA || parent_question_obj.type === self.QUESTION_TYPE_SELECT
                || parent_question_obj.type === self.QUESTION_TYPE_CHECKBOX || parent_question_obj.type === self.QUESTION_TYPE_RADIO)){
                try {
                    self.parent_question_answer = JSON.parse(question.parent_question_answer);
                } catch (e) { // Means is a plain text
                    self.parent_question_answer = [question.parent_question_answer];
                }
            }else{
                self.parent_question_answer = question.parent_question_id ? question.parent_question_answer : null;
            }
        }else{
            self.parent_question_answer = question.parent_question_id ? question.parent_question_answer : null;
        }
        self.question_entity_type = question.entity_type;
        self.question_group = question.group;
        self.question_phase_type = question.phase_type;

        if (question.choices) {
            self.question_choices = JSON.parse(question.choices).join("\n");
        } else {
            self.question_choices = null;
        }

        self.question_order = question.order;
        self.is_active = question.is_active ? true : false;
        self.is_required = question.is_required ? true : false;
        self.is_first_buyer_only = question.is_first_buyer_only ? true : false;
        self.initParentQuestionAnswersChoices(false);
        if(self.parent_question_answer_choices){
            self.clearSelectize('parent_answer_select_multiple');
            var _parent_question_answer = self.parent_question_answer;
            var _parent_question_answer_choices = self.parent_question_answer_choices.map(function(choice) {
                return { id: choice, name: choice };  // Create an object with id and name for each choice
            });
            self.$timeout(function(){
                var $select = $('#parent_answer_select_multiple').selectize({
                    valueField: 'id',
                    labelField: 'name',
                    sortDirection: 'desc',
                    maxItems: null,
                    options: _parent_question_answer_choices,
                    items: _parent_question_answer
                });}, 0);
        }
        self.updateNiceSelect();
        self.questionTypeTexOrChoices();
        self.standard_answer_ind = question.standard_answer_ind;
        self.standard_answer_corp = question.standard_answer_corp;
        self.localizeParam.question_text = self.getLocalizationValue('property_questions', question.id, 'question_text');
    }
    clearSelectize(id){
        const self = this;

        if(!id){
            return;
        }

        try{
            let selectize = $("#" + id)[0].selectize;

            if(selectize){
                selectize.destroy();
            }
        }
        catch(ex){
            console.log(ex);
        }
    }

    updateLocalLanguage() {
        const self = this;
        let url = 'language';

        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.$localStorage['language'] = response.data.language;
            // self.language = SHOWSUITE.data.language;
            self.$cookies.put('language-md5', response.data.md5);
        });
    }

    selectLanguageChanged() {
        const self = this;
        //Adding data to localizeParams
        self.localizeParam.question_text = self.getLocalizationValue('property_questions', self.update_question_id, 'question_text');

        if (self.editorLang) {
            self.editorLang.destroy();
        }

        var buttons = [
            'bold', 'italic', 'underline', 'strikeThrough',
            '|', 'subscript', 'superscript',
            '|', 'paragraphFormat', 'paragraphStyle', 'inlineStyle', 'align',
            '|', 'formatOL', 'formatUL', 'outdent', 'indent', 'selectAll',
            '-', 'insertHR', 'clearFormatting',
            '|', 'html',
            '|', 'undo', 'redo',
        ];

        self.editorLang = new FroalaEditor('div#froalaLang-editor', {
            key: self.EDITOR_API_KEY,
            toolbarInline: true,
            placeholderText: '',
            charCounterCount: false,
            height: 200,

            toolbarButtons: buttons,
            toolbarButtonsMD: buttons,
            toolbarButtonsSM: buttons,
            toolbarButtonsXS: buttons,

            htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr'],
            htmlRemoveTags: []
        }, function () {
            self.editorLang.html.set(self.localizeParam.question_text);
        });
    }

    getLocalizationValue(table, id, column_name) {
        const self = this;
        if (!table || !id || !column_name)
            return;
        if (self.language) {
            let result = self.language.filter(function (row) {

                return table + '.' + id + '.' + column_name + '.' + self.selectedLanguage == row.key;
            });
            if (result.length)
                return result[0].value;
            else
                return '';
        }
    }

    createLocalizationKey(table, id, column_name) {
        const self = this;
        if (!table || !id || !column_name)
            return;
        return table + '.' + id + '.' + column_name + '.' + self.selectedLanguage;
    }

    convertLocalizationParams() {
        const self = this;
        let params = {};
        params[self.createLocalizationKey('property_questions', self.property.id, 'question_text')] = self.localizeParam.question_text;
        return params;
    }

    saveLanguageParam() {
        const self = this;

        if (!self.selectedLanguage) {
            self.selectedLanguageError = 'Select Language to save';
            return;
        }
        self.localizeParam.question_text = new FroalaEditor('div#froalaLang-editor').html.get(true);


        let params = self.convertLocalizationParams();

        let url = 'language';

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'All data is saved successfully.');
            self.updateLocalLanguage();
        });
    }

    resetErrors() {
        const self = this;

        self.error_question_text = null;
        self.error_question_type = null;
        self.selectedLanguageError = null;
    }

    resetFields() {
        const self = this;

        self.update_question = false;
        self.add_question = false;

        self.parent_question_id = null;
        self.parent_question_answer = null;
        self.question_text = null;
        self.question_type = null;
        self.question_marker = null;
        self.question_entity_type = self.active_entity_type;
        self.question_group = null;
        self.question_phase_type = null;
        self.question_choices = null;
        self.question_order = null;
        self.parent_question_answer_choices = null;
        self.parent_question_answer_comparison = null;

        self.updateNiceSelect();
    }

    updateNiceSelect() {
        const self = this;

        self.$timeout(function () {
            $("select.eoi-select#questionaire_select").niceSelect('update');
        });
        self.$timeout(function () {
            $("select.eoi-select#parent_question_select").niceSelect('update');
        });
        self.$timeout(function () {
            $("select.eoi-select#group_select").niceSelect('update');
        });
        self.$timeout(function () {
            $("select.eoi-select#phase_type_select").niceSelect('update');
        });
    }

    hideModals() {
        const self = this;

        self.showQuestiontModal = false;
        self.showDeleteModal = false;

        if ($('#addQuestiontModal').is(':visible')) $('#addQuestiontModal').modal('hide');
        if ($('#deleteQuestiontModal').is(':visible')) $('#deleteQuestiontModal').modal('hide');
    }

    onMarkerChange() {
        const self = this;
        if (self.question_marker.includes('')) {
            self.question_marker = [''];  // Only keep 'None' selected
        }
        if (self.question_marker === self.QUESTION_MARKER_SPECIAL_CONDITIONS) {
            self.is_first_buyer_only = 1;
        }
    }

    isMarkerFirstBuyerOnly() {
        const self = this;

        return self.question_marker === self.QUESTION_MARKER_SPECIAL_CONDITIONS;
    }

    /** WEB-2891 Questionnaire issues **/
    initParentQuestionAnswersChoices(clearParentAnswerField = false){
        const self = this;
        self.parent_question_answer_choices = null;
        if(clearParentAnswerField){
            self.parent_question_answer = null;
            self.parent_question_answer_comparison = null;
        }

        if(!self.parent_question_id) { return null; }
        try{
            let parentQuestion = self.filtered_questions.find(q => q.id === self.parent_question_id);
            if(parentQuestion){
                if(parentQuestion.type === self.QUESTION_TYPE_YES_NO){
                    self.parent_question_answer_choices = ["YES", "NO"];
                }else if(parentQuestion.type === self.QUESTION_TYPE_YES_NO_NA){
                    self.parent_question_answer_choices = ["YES", "NO", "N/A"];
                }else if(parentQuestion.type === self.QUESTION_TYPE_SELECT ||
                        parentQuestion.type === self.QUESTION_TYPE_CHECKBOX ||
                        parentQuestion.type === self.QUESTION_TYPE_RADIO ){
                    if(parentQuestion.choices){
                        self.parent_question_answer_choices = JSON.parse(parentQuestion.choices)
                    }
                }

                if(self.parent_question_answer_choices){
                    self.clearSelectize('parent_answer_select_multiple');
                    var _parent_question_answer = self.parent_question_answer;
                    var _parent_question_answer_choices = self.parent_question_answer_choices.map(function(choice) {
                        return { id: choice, name: choice };  // Create an object with id and name for each choice
                    });
                    self.$timeout(function(){
                        var $select = $('#parent_answer_select_multiple').selectize({
                            valueField: 'id',
                            labelField: 'name',
                            sortDirection: 'desc',
                            maxItems: null,
                            options: _parent_question_answer_choices,
                            items: _parent_question_answer
                        });}, 0);
                }
            }
        }catch (e) {
            console.error(e);
        }
    }

    parentAnswerNoneSelected(){
        const self = this;
        if (self.parent_question_answer.includes('')) {
            self.parent_question_answer = [''];  // Only keep 'None' selected
        }

    }
}

PropertyQuestionnaireController.$inject = ['Upload','$window', '$sce', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'SSConfigService', 'SSUserService', 'OTPService', '$timeout','$localStorage','$cookies'];
app.controller('PropertyQuestionnaireController', PropertyQuestionnaireController);